import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { showToast } from '../../lib/toast'

export default class FloatCallout extends PureComponent {
  componentDidMount() {
    showToast(this.props.text, this.props.type)
  }

  render() {
    return null
  }
}

FloatCallout.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['error', 'success', 'warning']).isRequired,
}
